<template>
	<div class="goodList">
		<router-link :to="{
        path: '/detail',
        query: { id: item.id, type: 2, mid: mid, is_exchange: is_exchange,is_yun:is_yun }
      }" class="item acea-row row-between-wrapper" v-for="(item, index) in goodList" :key="index">
			<div class="pictrue">
				<img src="@assets/noshop.png" class="image" v-if="item.stock==0"/>
				<img :src="item.image" class="image" v-if="item.stock>0"/>
				<img src="@assets/images/one.png" class="numPic" v-if="isSort === true && index === 0" />
				<img src="@assets/images/two.png" class="numPic" v-if="isSort === true && index === 1" />
				<img src="@assets/images/three.png" class="numPic" v-if="isSort === true && index === 2" />
			</div>
			<div class="underline">
				<div class="text">
					<div class="line1 line3">
						<div v-if="item.is_recipel==1" style="display: inline-block;width:2.5em;vertical-align: bottom;">
							<img src="http://app.funengtuan.com/imgs/rx.png" style="width:100%;vertical-align: text-top;" />
						</div>
						<!-- <div> -->
							{{ item.store_name }}
						<!-- </div> -->
					</div>
					<div class="num2">
						已售{{ item.sales }}{{ item.unit_name }}
					</div>
					<div class="money font-color-red moneys" v-if="!item.vip_price || is_yun==1">
						<span class="num">￥{{ item.price }}</span>
						<div class="iconfont icon-caigou-xianxing icon-caigou-xianxing222"></div>
						<!-- <span class="num2">已售{{ item.sales }}{{ item.unit_name }}</span> -->
					</div>
					<div class="vip-money row-middle">
						<div class="vip" v-if="item.vip_price && item.vip_price > 0 && is_yun!=1">
							￥{{ item.vip_price || 0}}<img src="@assets/images/vip.png" class="image" />
						</div>
						<!-- <div class="num">已售{{ item.sales }}{{ item.unit_name }}</div> -->
					</div>
				</div>
			</div>
			<!--      <div
        class="iconfont icon-gouwuche cart-color acea-row row-center-wrapper"
      ></div> -->
		</router-link>
	</div>
</template>
<script>
	export default {
		name: "GoodList",
		props: {
			is_exchange: {
				type: Number,
				default: () => []
			},
			is_yun: {
				type: Number,
				default: () => []
			},
			mid: {
				type: Number,
				default: () => []
			},
			goodList: {
				type: Array,
				default: () => []
			},
			isSort: {
				type: Boolean,
				default: true
			}
		},
		data: function() {
			return {};
		}
	};
</script>
<style>
	.goodList {
		display: flex;
		display: -webkit-flex;
		justify-content: space-between;
		flex-direction: row;
		flex-wrap: wrap;
	}

	.goodList .item {
		width: 50%;
		padding: 0 2% !important;
	}

	.goodList .item .pictrue {
		width: auto !important;
		height: 172.5px !important;
		margin: 0 auto;
	}

	.goodList .item .underline {
		width: 100% !important;
		padding: 0.3rem 0rem 0.3rem !important;
	}

	.line3 {
		font-size: 0.33rem !important;
		font-weight: 700 !important;
		text-align: left !important;
	}

	.goodList .item .text {
		text-align: center !important;
		width: 100% !important;
	}

	.goodList .item .text .money {
		text-align: left !important;
		margin-top: 0.1rem !important;
	}

	.num2 {
		text-align: left !important;
		color: #cccccc !important;
		font-size: 0.22rem !important;
		margin-top: 0.1rem;
		padding-left: 4px;
	}

	.moneys {
		display: flex !important;
		justify-content: space-between !important;
		align-items: center !important;
		font-weight: 400 !important;
	}

	.icon-caigou-xianxing222 {
		font-size: 0.4rem !important;
	}
</style>
